module.exports = __webpack_public_path__ + "img/bgr-cardboard-boxes@2x.b7dc6794.png";